module.exports = __webpack_public_path__ + "static/media/hea_haz_lev.21350e49.png";